// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__37J9x","errorLogs":"EditorFooter_errorLogs__3ehYR"};